export default {
    'odkryj_dostep':'Entdecken Sie alle Kategorien und genießen Sie vollen Zugriff.',
			'odkryj_dostep_opis':  'Nur ein Spieler zahlt und schaltet das Spiel für beide frei!',
            'kontynuuj_gre':  'Weiterspielen',
            'zacznij_od_nowa':  'Fang nochmal an',
            'dolacz_do_gry':  'Nimm am Spiel teil',
            'prosze_czekac':  'Warten Sie mal',
            'zamknij':  '<i class="fa fa-times"></i> Schließen',
            'start_gry':  "Spielbeginn",
			'graj':  'Spielen',
			'wpisz_imiona_graczy':'Spielernamen eingeben',
			'twoje_imie':'Ihren Namen',
			'imie_drugiego_gracza':'Name des zweiten Spielers',
			'wyslij_zaproszenie':  'Einladung senden <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia':  'Verbindungsaufbau',
			'daj_drugiemu':  "Geben Sie dem anderen Spieler, den Code unten zu scannen",
			'wpisz_imiona':  'Geben Sie die Namen beider Spieler ein',
			'wpisz_rozne_imiona':  'Unterschiedliche Namen eingeben',
			'odblokowane':  'Alle Stufe wurden freigeschaltet. Spiel weiter!',
			'poziomy':  'Kategorien',
			'rozpocznij_gre':  'Spiel starten <i class="fas fa-chevron-right"></i>',
			'poziom1':  'Stufe 1',
			'poziom2':  'Stufe 2',
			'poziom3':  'Stufe 3',
			'oczekuje_na_druga_osobe':  'Warten auf die Antwort der anderen Person',
			'oczekuje_na_druga_osobe_2': 'Auf den anderen warten',
			'graj_dalej':  'Spiel weiter <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre':  'Beende das Spiel <i class="fas fa-chevron-right"></i>',
			'odpowiadaj_na_pytania':  'Fragen beantworten',
			'pytanie':  'Frage',
			'z':'Mit',
			'oczekuje_na_osobe':  'Warten auf die Antwort der anderen Person',
			'wyniki_rozgrywki':  "Spielergebnisse",
			'gratulacje':  "Glückwunsch",
			'macie_zgodnosc':  "Ihr seid kompatibel",
			'znasz_grugiego_gracza':  "Du kennst den anderen Spieler an",
			'zna_ciebie':  "kennt dich aus",
			'jak_odpowiadaliscie':  '<i class="fas fa-tasks"></i> Sehen Sie, wie Sie geantwortet haben',
			'pochwal_sie':  '<i class="fas fa-share-alt"></i> Zeigen Sie Ihre Punktzahl',
			'wasze_odpowiedzi':  "deine Antworten",
			'skanuj_kod':"Code scannen",
			'statystyka':  "Statistiken",
			'statystyka_gry':  "Spielstatistik",
			'powiadom':  '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Über neue Version benachrichtigen',
			'zapisalismy_cie':  'Wir haben Ihre E-Mail-Adresse gespeichert',
			'rozpocznij':  'Starte <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie':  "Sich kennenlernen",
			'jak_znasz':  "Matching Halfs ist ein Spiel für Paare, das testen wird, wie gut Sie Ihren Partner kennen und wie gut er Sie kennt.",
			'help1':  "Sie haben das Spiel bereits gestartet. Wenn Sie es fortsetzen möchten, drücken Sie die Taste unten.",
			'help2':  "Sie möchten das Spiel jedoch erneut oder mit einem neuen Spieler beginnen - drücken Sie die Schaltfläche unten.",
			'help3':  "Sei der erste Spieler, der das Spiel einrichtet - füge Spielernamen hinzu und lasse den zweiten Spieler den generierten Code scannen.",
			'help4':  "Nachdem der erste Spieler den Code generiert hat, drücken Sie die Schaltfläche unten und scannen Sie den Code.",
			'help5':  "Nachdem Sie die Namen der Spieler eingegeben haben, klicken Sie auf die Schaltfläche \"Einladung senden\" und lassen Sie den generierten Code vom anderen Spieler scannen.",
			'help6':  "Geben Sie dem anderen Spieler, den Code unten zu scannen",
			'help7':  "Scanne den vom anderen Spieler generierten Code",
			'kup':  "Besorgen",
			'zagraj_ponownie':  '<i class="fas fa-play" style="right:auto; left: 15px"></i> Erneut spielen',
			'opis_gry':  'Spielbeschreibung',
			'poziom':  'Eben',
			'ext_desc':  '<br>Matching Halves ist ein Spiel für Paare, mit dem Sie testen können, wie gut Sie Ihren Partner kennen und wie gut er Sie kennt.<br><br>Sie spielen gleichzeitig online auf zwei Geräten. Sie müssen beide das Spiel aus dem Store herunterladen.<br><br>Eine Person startet das Spiel, indem sie auf die Schaltfläche "Spiel starten" klickt und ihre Namen eingibt.<br><br>Die andere Person tritt dem Spiel bei, indem sie auf klickt Schaltfläche „Spiel beitreten“ und scannt den Code, der von der Person generiert wurde, die das Spiel startet. Nach dem Scannen des Codes werden beiden Spielern der Spielstart und die Kategorien angezeigt.<br><br>Die Anwendung hat 6 Kategorien mit jeweils 3 Schwierigkeitsgraden. Du beginnst mit dem einfachsten Stufe, d. h. Stufe 1 (das Beenden von Stufe 1 ermöglicht es dir, mit dem nächsten zu beginnen).<br><br>Lass dich nicht von scheinbar einfachen Fragen entmutigen, denn je weiter in den Wald hinein, desto schwieriger wird es und würziger!<br><br>W Gleichzeitig erscheint dieselbe Frage auf Ihren Telefonen oder Tablets, auf die Sie mit Ja / Nein antworten oder eine bestimmte Antwort markieren. Ihre Aufgabe besteht nur darin, auf die richtige Antwort zu klicken.<br><br>Zuerst antworten Sie, was Ihr Partner denkt, dann antworten Sie für sich selbst, was Sie denken. Nach jedem Stufe können Sie überprüfen, wie Sie geantwortet haben und wie viel Prozent Sie erreicht haben.<br><br>Sie können das Spiel jederzeit beenden und später beenden, aber wenn Sie das Spiel erneut starten, werden Ihre vorherigen Antworten gelöscht.<br> <br>Viel Spaß!<br><br><br><br><br><br>',
			'druga_osoba_odpowiedziala':  'Die andere Person wartet auf Ihre Antwort',
			'confirm_text_1':  'Möchtest du das Spiel von vorne beginnen?',
			'confirm_text_2':  'Ihre bisherigen Antworten gehen verloren.',
			'yes_button':  '<i class="fa fa-check"></i> Ja, ich fange neu an',
			'no_button':  '<i class="fa fa-times"></i> Nein, ich spiele noch',
			'back':  '<i class="fas fa-chevron-left"></i> zurück',
			'backk':  '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Zurück',
			'podsumowanie_wynikow':  'Ergebniszusammenfassung<i class="fas fa-chevron-right"></i>',
						
			
			'Życie codzienne': 'Alltagsleben',
			'Daily life': 'Alltagsleben',
			'La vida cotidiana': 'Alltagsleben',
			'Vie courante': 'Alltagsleben',
			'Alltagsleben': 'Alltagsleben',
			'Vita di ogni giorno': 'Alltagsleben',
			'Vida cotidiana': 'Alltagsleben',
			
			'Osobowość / charakter': 'Persönlichkeit Charakter',
			'Personalità/carattere': 'Persönlichkeit Charakter',
			'Personality / character': 'Persönlichkeit Charakter',
			'Caracter personal': 'Persönlichkeit Charakter',
			'Caractère de la personnalité': 'Persönlichkeit Charakter',
			'Personalidade / personagem': 'Persönlichkeit Charakter',
			'Persönlichkeit Charakter': 'Persönlichkeit Charakter',
			
			'Życie towarzyskie': 'Soziales Leben',
			'Social life': 'Soziales Leben',
			'Vida social': 'Soziales Leben',
			'Vie sociale': 'Soziales Leben',
			'Soziales Leben': 'Soziales Leben',
			'Vita sociale': 'Soziales Leben',
			
			'Wyznawane wartości': 'Vertraute Werte',
			'Values / beliefs': 'Vertraute Werte',
			'Valores propugnados': 'Vertraute Werte',
			'Valeurs adoptées': 'Vertraute Werte',
			'Valores expostos': 'Vertraute Werte',
			'Vertraute Werte': 'Vertraute Werte',
			'Valori sposati': 'Vertraute Werte',
			
			'Nałogi / nawyki': 'Süchte / Gewohnheiten',
			'Habits / Addictions': 'Süchte / Gewohnheiten',
			'Adicciones / hábitos': 'Süchte / Gewohnheiten',
			'Dépendances / habitudes': 'Süchte / Gewohnheiten',
			'Vícios / hábitos': 'Süchte / Gewohnheiten',
			'Süchte / Gewohnheiten': 'Süchte / Gewohnheiten',
			'Dipendenze/abitudini': 'Süchte / Gewohnheiten',
			
			'Seks':'Sex',
			'Sex':'Sex',
			'Sexo':'Sex',
			'Sexe':'Sex',
			'Sesso':'Sex',
			
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',

			'jasny': 'Hell',
			'ciemny': 'Dunkel',
			
			'blad_polaczenia': "Verbindungsfehler. Versuche es erneut.",
			'przekaz_kod_gry': "Dein Spielcode",
			'przekaz_kod_gry_drugi_gracz': "Du kannst auch den Spielcode für den zweiten Spieler weitergeben",
			"skanuj_kod_aparatem": "Scanne den Code mit der Kamera",
  "wpisz_kod_recznie": "Gib den Code manuell ein",
 "wprowadz_kod": "Gib den erhaltenen Code ein",
  "wprowadz_kod_gry": "Gib den Spielcode ein",
  "help8": "Gib im folgenden Feld den Spielcode ein, den du vom zweiten Spieler erhalten hast. Nach der Eingabe startet das Spiel automatisch",
    "nieprawidlowy_kod_gry": "Der eingegebene Code ist ungültig",
"powrot_do_kategorii": "Zurück zu den Kategorien"




}